// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"105":"2f2b1e95","230":"43ed44b6","248":"27b2d7b5","405":"5546a8dc","431":"b621aa8d","483":"71aebd54","526":"b98f3efc","614":"f7bb2818","615":"49f881f2","687":"42cd5b16","775":"a3a40ebb","779":"6b778c22","856":"403bb1d3","935":"97e4c12b","963":"93ef5350"}[chunkId] + ".js";
};